/**
 * useTerminalTheme
 *
 * Single source of truth for "is the terminal theme active right now?".
 * Every surface in the app that forks between the terminal UI and the
 * classic UI should use this hook so the check is consistent, centrally
 * documented, and trivially refactorable if we ever add more themes
 * (say `solarized`).
 *
 * Implementation: reads the active theme from `ThemeCustomizerContext`
 * and compares slug. The context already subscribes to Firestore +
 * auth, so there's no extra DOM work and the value stays reactive to
 * theme switches without any MutationObserver plumbing.
 *
 * Do not read `document.documentElement.getAttribute('data-app-theme')`
 * directly anywhere else — centralise here.
 */

import { useThemeCustomizer } from '../contexts/ThemeCustomizerContext';

export function useTerminalTheme(): boolean {
  const { activeTheme } = useThemeCustomizer();
  return activeTheme?.slug === 'terminal';
}
